<template>

    <div class="panel panel-clinic">

        <div class="panel-heading collapsed" href="#form_connection_external" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">Anslutning företagsmassör</h2>

        </div>

        <div id="form_connection_external" class="panel-collapse collapse">

            <div class="panel-body">

                <div class="form-horizontal">

                    <div class="form-group oddevencol">
                        <label class="col-md-14 control-label">Skickat välkomstmail (via systemet)</label>
                        <div class="col-md-36">
                            <p>{{ clinic.contract_external_sent }}</p>
                        </div>
                    </div>

                    <div class="form-group oddevencol">
                        <label class="col-md-14 control-label">Skickat demokort (via systemet, om aktuellt)</label>
                        <div class="col-md-36">
                            <p>{{ clinic.demo_card_sent }}</p>
                        </div>
                    </div>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        type="checkbox_timezynk_is_user"
                        layout="checkBox"
                        title="Upplagd som användare TimeZynk">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        type="text_timezynk_id"
                        layout="textBox"
                        title="TimeZynk ID (24 tecken)"
                        :comment="timezynkComment">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showComment="true"
                        type="checkbox_shirt"
                        layout="checkBox"
                        title="Har fått arbetströja">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :extra-data="{'Inget val': 1, 'Pike': 2, 'T-shirt': 3}"
                        :showComment="true"
                        type="select_shirt_type"
                        layout="selectMenu"
                        title="Variant av tröja">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :extra-data="{
                            'Inget val': 1,
                            'WXS': 'WXS',
                            'WS': 'WS',
                            'WM': 'WM',
                            'WL': 'WL',
                            'WXL': 'WXL',
                            'MS': 'MS',
                            'MM': 'MM',
                            'ML': 'ML',
                            'MXL': 'MXL',
                        }"
                        :showComment="true"
                        type="select_shirt_size"
                        layout="selectMenu"
                        title="Storlek på tröja">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        type="textarea_shirt_size"
                        layout="textBox"
                        title="Tröjstorlek"
                        comment="(Gamla rutan)">
                    </row-meta>

                </div>

                <div class="form-horizontal">

                    <div class="row row-meta oddevencol validateRule approvedIntExt" v-bind:class="{ complete: validateRule('rule_reconciliation_external') }">
                        <div class="col-md-50 control-label first withcomm">
                            <label style="font-weight:normal;">Godkänd avstämning med företagsmassör</label>
                        </div>
                    </div>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_sign_in_external"
                        layout="checkBox"
                        title="Har massören loggat in på MP?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_payment_account_external"
                        layout="checkBox"
                        title="Har massören lagt in sina bankuppgifter?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_payment_invoice_external"
                        layout="checkBox"
                        title="Alternativ till bankuppgifter; fakturerar via externt faktureringbolag">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_timezynk_sign_in"
                        layout="checkBox"
                        title="Har massören loggat in på TimeZynk?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_timezynk_download"
                        layout="checkBox"
                        title="Har massören laddat ned TimeZynk App i sin mobil?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_timezynk_schedule"
                        layout="checkBox"
                        title="Förstår massören hur hen ser sitt schema i TimeZynk (app eller dator)?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_timezynk_requests"
                        layout="checkBox"
                        title="Förstår massören hur förfrågningar skickas via TimeZynk?">
                    </row-meta>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showForced="true"
                        :showDate="true"
                        :showComment="true"
                        type="checkbox_reconciliation_timezynk_time_report"
                        layout="checkBox"
                        title="Förstår massören hur tidrapportering ska skötas?">
                    </row-meta>


                </div>

                <div class="form-horizontal">
                    
                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :extra-data="admins"
                        :showDate="true"
                        type="select_contact_manager"
                        layout="selectMenuArray"
                        title="Överlämning till kontaktansvarig">
                    </row-meta>

                    <div class="form-group oddevencol" v-if="meta.select_contact_manager && meta.select_contact_manager.value">
                        <label class="col-md-14 control-label">Maila kontaktansvarig</label>
                        <div class="col-md-36">
                            <div class="btn btn-default" v-on:click="notifyContactManager()">Skicka mail</div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

    import mixin from './mixin'

    export default {

        mixins: [mixin],

        data() {

            return {



            }

        },


        computed: {

            admins() {

                var admins = []

                admins.push({

                    value: null,
                    text: 'Välj'

                })

                _.forEach(_.filter(this.users, ['type', 'admin']), function(admin) {

                    admins.push({

                        value: admin.id,
                        text: admin.name

                    })

                })

                return admins

            },

            timezynkComment ()
            {
                if (this.meta['text_timezynk_id'].value && this.meta['text_timezynk_id'].value.length != 24) {
                    return '<b style="color: red;">Felaktigt TimeZynk ID!</b>'
                }
            }

        },

        methods: {

            notifyRegionManager() {
                var self = this;
                self.$http.post('/clinics/notifyRegionManager', { clinic_id: self.clinic.id } ).then((response) => {
                    console.log(response.body);
                    bus.$emit('notify', 'Mail skickat till regionansvarig.')
                }, (response) => {
                    console.log(JSON.stringify(response));
                });
            },
            notifyContactManager() {
                var self = this;
                self.$http.post('/clinics/notifyContactManager', { clinic_id: self.clinic.id } ).then((response) => {
                    console.log(response.body);
                    bus.$emit('notify', 'Mail skickat till kontaktansvarig.')
                }, (response) => {
                    console.log(JSON.stringify(response));
                });
            },

        }

    }

</script>
